<template>
  <!-- 面包屑导航 -->
  <div class="bread-box">
    <div class="main-bread-box">
      <span class="cur-position">
      <i class="iconfont icon-zuobiao"></i>
    </span>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <slot></slot>
    </el-breadcrumb>
    </div>
  </div>
</template>
<script>
export default {
  name: "BreadCrumb"
}
</script>
<style lang="scss" scoped>
.bread-box {  
  padding: 6px 0;
  background: $color-F3F4F5;
  .main-bread-box{
    display: flex;
    align-items: center;
    width: 1200px;
    margin: 0 auto;
  }
	.icon-zuobiao:before {
		content: "\e650";
		font-size: 16px;
		margin-right: -2px;
	}
  .cur-position {
    font-size: 14px;
    color: $color-3;
    i {
      font-size: 14px;
      margin-right: 2px;
    }
  }
  ::v-deep .el-breadcrumb {
    margin-left: 5px;
    .el-breadcrumb__item {
      &:last-child .el-breadcrumb__inner {
        &,
        &:hover,
        a,
        a:hover {
          color: $theme-color;
        }
        .el-breadcrumb__separator {
          margin: 0 4px;
        }
      }
      &.isLink .el-breadcrumb__inner,
      a {
        font-weight: bold;
        text-decoration: none;
        transition: color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
        color: $theme-color !important;
        &:hover {
          color: $theme-color;
          cursor: pointer;
        }
      }
    }
  }
}
</style>